import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";
import { TransferListItemSchema, TransferOrderStatus } from "./transfer-types";

export const getTransfers = {
  name: "getTransfers" as const,
  input: z.object({
    status: TransferOrderStatus.optional(),
    statusFilter: z.array(z.string()).optional(),
    originLocationId: locationIdFormat.schema.optional(),
    destinationLocationId: locationIdFormat.schema.optional(),
    search: z.string().optional(),
    limit: z.number().int().min(1).max(100).default(50),
    offset: z.number().int().min(0).default(0),
  }),
  output: z.object({
    transfers: z.array(TransferListItemSchema),
    total: z.number().int(),
  }),
};
